import styled, { keyframes } from "styled-components";
import { paletas } from "../../styles/theme";

const slide = keyframes`
  from {
    opacity: 0;
    right: -20px;
  }

  to {
    opacity: 1;
    right: 0px;
  }
`;

export const Wrapper = styled.header`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 10px 20px;
  transition: all 0.25s;

  .logo {
    transition: all 0.25s;
    margin-right: 20px;
  }

  a {
    text-decoration: none;
  }

  .ancora-logo {
    transition: all 0.25s;
    display: none;
  }

  @media (min-width: 576px) {
    padding: 20px;

    .ancora-logo {
      display: block;
    }
  }
`;

export const BotaoMenu = styled.button`
  position: relative;
  max-height: 40px;
  color: ${paletas.White};
  background: ${paletas.DarkOrange};
  padding: 10px 10px 8px;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  z-index: 2;
  transition: all 0.5s;
`;

export const Menu = styled.div`
  transition: all 0.5s;
  display: flex;
  position: absolute;

  & nav {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 250px;
    height: 100vh;
    background: ${paletas.Grafite75};
    position: fixed;
    right: 0;
    transition: all 0.25s;
    animation: ${slide} 0.25s;
    z-index: 1;
  }

  ul {
    list-style: none;
    margin-top: 80px;
  }

  li {
    text-align: center;
    position: relative;
    padding: 10px;
  }

  a {
    color: ${paletas.White};
    text-decoration: none;

    &:before {
      transition: all 0.25s ease;
      content: "";
      width: 100px;
      height: 1px;
      background-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0),
        ${paletas.DarkOrange} 40%,
        ${paletas.DarkOrange} 60%,
        rgba(0, 0, 0, 0)
      );
      position: absolute;
      left: 75px;
      bottom: 0;
      opacity: 0;
    }

    &:hover {
      color: ${paletas.White};

      &:before {
        opacity: 1;
      }
    }
  }

  button {
    padding: 10px;
    width: 100%;
    background: ${paletas.RedTheme};
    color: ${paletas.White};
    border-radius: 0.25rem;
    border: none;
    text-transform: uppercase;
    font-size: 16px;
  }
`;

export const Versao = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  color: ${paletas.DarkOrange};
`;
